import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';

function AdminProtectedRoute({children}) {
    const {isAdminAuthenticated} = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if(!isAdminAuthenticated) navigate('/login')
    }, [isAdminAuthenticated, navigate])

    return isAdminAuthenticated ? children : null
}

export default AdminProtectedRoute